import isEmpty from "lodash/isEmpty"
import React from "react"

/**
 * Higher-order component that wraps a component and passes it a transformed model prop.
 * @function
 * @param {React.Component} WrappedComponent - The component to wrap.
 * @returns {React.Component} The wrapped component with a transformed model prop.
 */
export default (WrappedComponent) => {
  const WrappedComponentWithSSRModel = ({ model = null, ...rest }) => {
    let cleanedProps = { ...rest }
    if (!isEmpty(model)) {
      cleanedProps = {
        ...rest,
        ...model,
      }
    }

    return <WrappedComponent {...cleanedProps} />
  }

  // Note: React 19 no-longer supports propTypes. Leaving this for reference.
  // WrappedComponentWithSSRModel.propTypes = {
  //   model: PropTypes.object,
  // }

  // Note: React 19 no-longer supports defaultProps. Leaving this for reference.
  // WrappedComponentWithSSRModel.defaultProps = {
  //   model: null,
  // }

  return WrappedComponentWithSSRModel
}
